module.exports = __webpack_public_path__ + "img/open_senior.fc8d752c.png";